module.exports = __webpack_public_path__ + "static/media/frame_gold_landscape.5e200d22.png";